module.exports = __webpack_public_path__ + "img/down_sch_banner.45e57af3.png";